import { initialState } from "./state"

export default {
  setFilterStartDate: (state, payload) => (state.filters.startDate = payload),
  setFilterEndDate: (state, payload) => (state.filters.endDate = payload),
  setExportationTypes: (state, payload) =>
    (state.filters.exportationTypes = payload),
  resetList: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  }
}
